













































































import { Component, Vue } from "vue-property-decorator";
import {
  NavItem,
  SideBarGetter,
  SideBarMutation
} from "@/components/sidebar/types";
import { NavItems } from "@/helpers/constants";
import SpatialNavigation from "spatial-navigation-js";
import { Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { RouteName } from "@/router/types";
import HomeIcon from "@/assets/svg/svg-home/00-home.vue";
import Home from "@/components/homePage/Home.vue";
import ChannelsIcon from "@/assets/svg/svg-home/01-channels.vue";
import BuffetIcon from "@/assets/svg/svg-home/02-buffet.vue";
import SettingsIcon from "@/assets/svg/svg-home/07-settings.vue";
import { ProviderData } from "@/services/apiService/api.types";
import apiStorageInterface, {
  defaultProviderData
} from "@/services/apiStorageInterface";
import { LocaleSidebarString } from "@/plugins/i18n/types";
import { i18n } from "@/plugins/i18n/vue-i18n-plugin";
import VodIcon from "@/assets/svg/svg-home/03-vod.vue";

@Component({
  components: {
    Home,
    HomeIcon,
    ChannelsIcon,
    BuffetIcon,
    SettingsIcon,
    VodIcon
  }
})
export default class Sidebar extends Vue {
  @Mutation(SideBarMutation.SetSideBarOpen, { namespace: Namespace.SideBar })
  setSideBarOpen!: (sidebarOpenStatus: boolean) => void;

  @Getter(SideBarGetter.GetSideBarOpen, { namespace: Namespace.SideBar })
  getSideBarOpen!: boolean;

  navItemsBlank: NavItem[] = NavItems;

  providerData: ProviderData = defaultProviderData;
  get navItems(): NavItem[] {
    let translatedNavItems = NavItems;
    translatedNavItems.forEach((item, index) => {
      switch (index) {
        case 0:
          item.text = i18n.t(LocaleSidebarString.home) as string;
          break;
        case 1:
          item.text = i18n.t(LocaleSidebarString.channels) as string;
          break;
        case 2:
          item.text = i18n.t(LocaleSidebarString.buffet) as string;
          break;
        case 3:
          item.text = i18n.t(LocaleSidebarString.vod) as string;
          break;
        case 4:
          item.text = i18n.t(LocaleSidebarString.settings) as string;
          break;
      }
    });

    return translatedNavItems;
  }

  get logo(): string {
    if (this.providerData.logo) {
      return this.providerData.logo.url;
    }
    return require("/src/assets/images/next-logo-light.png");
  }

  async created(): Promise<void> {
    this.providerData = await apiStorageInterface.fetchProviderData();
  }

  focusNavItem(): void {
    this.navItems.forEach((item, index) => {
      if (item.routeName === this.$route.name) {
        SpatialNavigation.focus("#" + this.navItems[index].routeName);
        this.setSideBarOpen(true);
      }
    });
  }

  async openPage(routeName: RouteName): Promise<void> {
    if (this.$route.name !== routeName) {
      await this.$router.push({ name: routeName });
      this.focusNavItem();
    }
  }

  navActions(event: KeyboardEvent, navItem: NavItem): void {
    SpatialNavigation.pause();
    switch (keyCodeFinder(event.keyCode)) {
      case KeySet.KEY_RIGHT:
        // making sure that navigation occurs only after the route has been set
        if (this.$route.name === navItem.routeName) {
          setTimeout(() => {
            SpatialNavigation.focus(navItem.defaultElement);
          });
          this.setSideBarOpen(false);
        }
        break;
    }
    SpatialNavigation.resume();
  }
}
